var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$options.name, 'white']},[_c('div',{staticClass:"container"},[_c('ul',{staticClass:"menu -ul"},_vm._l((_vm.routes),function(route,index){return _c('li',{key:("route-" + index),staticClass:"menu -li"},[_c('button',{class:[
                        'url', 
                        { 
                            '-active': _vm.$route.name === 'home' && route === _vm.getActiveRoute() 
                        }
                    ],on:{"click":function($event){return _vm.goToSection(route)}}},[_vm._v("\n                    "+_vm._s(route)+"\n                ")])])}),0),_c('mentions')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }